
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Nîmes dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Nîmes certifiée Google Partner, accompagne les entreprises nîmoises pour renforcer leur présence en ligne et développer leur portefeuille clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Nîmes dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Nîmes certifiée Google Partner, accompagne les entreprises nîmoises pour renforcer leur présence en ligne et développer leur portefeuille clients.",
        },
      ],
    };
  },
};
